import { ComplianceProfileCommentForWarning } from "../../compliance-conditional-rules/enums";
import { ComplianceProfileRuleSeverity } from "../../compliance-nested-rules";
export const ComplianceProfileRulesAssociationConstants = {
    COMPLIANCE_CONDITIONAL_RULES_SEARCH_INPUT_ID: 'search-input',
    COMPLIANCE_MITCHELL_RULES_SEARCH_INPUT_ID: 'mitchellrules-search-input',
    COMPLIANCE_RULES_SEARCH_RULE: 'Search Rule',
    COMPLIANCE_CONDITIONAL_RULES_DATA_GRID_ID: 'compliance-profile-associated--conditional-rules',
    COMPLIANCE_MITCHELL_RULES_DATA_GRID_ID: 'compliance-profile-associated-mitchell-rules',
    COMPLIANCE_RULES_GRID_HEADER_WIDTH_IN_PERCENTAGE_30: 30,
    COMPLIANCE_RULES_GRID_HEADER_WIDTH_IN_PERCENTAGE_65: 65,
    COMPLIANCE_RULES_GRID_HEADER_WIDTH_IN_PERCENTAGE_5: 5,
    COMPLIANCE_RULES_PAGE_SIZE: 40,
    COMPLIANCE_RULES_SELECTED_RULE: 'selectedRule',
    COMPLIANCE_RULES_RULE_NAME: 'ruleName',
    COMPLIANCE_RULES_RULE_DESCRIPTION: 'ruleDescription',
    COMPLIANCE_RULES_RULE_DESC_MAX_LENGTH: 80,
    COMPLIANCE_RULES_RULE_NAME_MAX_LENGTH: 45,
    COMPLIANCE_RULES_NAME: 'Rule Name',
    COMPLIANCE_NO_OPTIONS_MESSAGE: 'No options',
    COMPLIANCE_RULES_DESCRIPTION: 'Rule Description',
    COMPLIANCE_RULES_NAME_KEY: 'ruleName',
    COMPLIANCE_RULES_NO_CONDITIONAL_RULES_CUSTOM_ROW: 'No Conditional Rules have been created.',
    COMPLIANCE_RULES_NO_MITCHELL_RULES_CUSTOM_ROW: 'No Mitchell Rules have been created.',
    COMPLIANCE_CONDITIONAL_RULES_SELECT_ALL_CHECKBOX: 'selectAllConditionalRulesId',
    COMPLIANCE_MITCHELL_RULES_SELECT_ALL_CHECKBOX: 'selectAllMitchellRulesId',
    COMPLIANCE_PROFILE_VISIBILITY_VISIBLE: 'Visible',
    COMPLIANCE_PROFILE_VISIBILITY_HIDDEN: 'Hidden',
    COMPLIANCE_PROFILE_NAME: 'Profile Name',
    COMPLIANCE_PROFILE_VERSION: 'Version',
    COMPLIANCE_EXTENDED_PROFILE_VERSION: 'Profile Version',
    COMPLIANCE_PROFILE_CREATION_DATE: 'Creation Date',
    COMPLIANCE_PROFILE_DESCRIPTION: 'Profile Description',
    COMPLIANCE_PROFILE_MANAGED_BY: 'Managed By',
    COMPLIANCE_PROFILE_RESULT_VISIBILITY: 'Compliance Result Visibility',
    COMPLIANCE_PROFILE_DEFAULT_VERSION: 'v1',
    COMPLIANCE_EXTENDED_PROFILE_DEFAULT_VERSION: 'v0',
    COMPLIANCE_PROFILE_DEFAULT_MANAGED_BY: 'XXXXXXX',
    COMPLIANCE_PROFILE_NAME_ID: 'complianceProfileName',
    COMPLIANCE_PROFILE_DESCRIPTION_ID: 'complianceProfileDescrition',
    COMPLIANCE_PROFILE_RESULT_VISIBILITY_ID: 'complianceProfileResultVisibility',
    COMPLIANCE_PROFILE_NAME_VALIDATE_SPECIAL_CHAR: new RegExp("^[a-zA-Z0-9&\\-,\\s.'/_+()]*$"),
    COMPLIANCE_PROFILE_REGEX_VALIDATE_PROFILENAME: new RegExp("^[a-zA-Z0-9&\\-,\\s.'/_+()]{0,50}$"),
    PROFILE_NAME_SPECIAL_CHARACTER_ERROR: "Only following special characters are allowed & , . ' / - _ + ( )",
    COMPLIANCE_RULES_SEVERITY_DATAKEY: 'severity',
    COMPLIANCE_RULES_REVIEWER_OPTION_DATAKEY: 'reviewerOption',
    COMPLIANCE_RULES_CREATED_DATE_DATAKEY: 'createdDate',
    COMPLIANCE_RULES_CONDITIONAL_RULE_MODAL: 'conditionalRuleAssociationModalID',
    COMPLIANCE_RULES_RESULT_TYPE: 'Result Type',
    COMPLIANCE_RULES_CREATED_DATE: 'Created Date',
    CRITICAL_TOOLTIP_DESCRIPTION: 'Stops estimate commit if critical rules fail (Note: custom setting must be ON)',
    FAILURE_TOOLTIP_DESCRIPTION: 'Requires estimator comment for any failure after estimate commit',
    WARNING_TOOLTIP_DESCRIPTION: 'Displays a visual indicator to estimator/appraiser, not flagged for review',
    COMPLIANCE_SEVERITY_CRITICAL_FAILURE: 'Critical Failure',
    COMPLIANCE_SEVERITY_WARNING: 'Warning',
    COMPLIANCE_SEVERITY_REQUIRED: 'Failure',
    COMPLIANCE_REVIEWER_OPTION_HIDDEN: 'Hidden',
    COMPLIANCE_REVIEWER_OPTION_ESCALATED: 'Escalated',
    COMPLIANCE_RULENAME_DESC_GRID_ID: 'ruleNameDescTextContainer',
    COMPLIANCE_RULENAME_DESC_LESS_BUTTON: 'less',
    COMPLIANCE_RULENAME_DESC_MORE_BUTTON: 'more',
    COMPLIANCE_PROFILE_ASSOCIATED_RULE_REVIEWER_OPTION: 'REVIEWER OPTION',
    COMPLIANCE_PROFILE_ASSOCIATED_RULE_HIDE_FROM_APPRAISER: 'Hide from Appraiser',
    COMPLIANCE_PROFILE_ASSOCIATED_RULE_ESCALATED_REVIEW: 'Escalated to Review',
    COMPLIANCE_PROFILE_MITCHELLRULE_MODAL_ID: 'mitchellRuleAssociationModalID',
    COMPLIANCE_PROFILE_LESS_MOREBTN_ID: 'complianceMoreLessButtonId',
    CONDITIONAL_RULE_COMMENT_FOR_WARNING_DATAKEY: 'commentRequiredForOptionalInd',
    CONDITIONAL_RULE_COMMENT_FOR_WARNING: 'Comment for Warning?'
};
export const complianceSeverityRankMapEN = {
    [ComplianceProfileRuleSeverity.CRITICAL]: 0,
    [ComplianceProfileRuleSeverity.REQUIRED]: 1,
    [ComplianceProfileRuleSeverity.OPTIONAL]: 2
};
export const complianceSeverityRankMapFR = {
    [ComplianceProfileRuleSeverity.OPTIONAL]: 0,
    [ComplianceProfileRuleSeverity.REQUIRED]: 1,
    [ComplianceProfileRuleSeverity.CRITICAL]: 2 // Échec critique
};
export const complianceCommentForWarningRankMapEN = {
    [ComplianceProfileCommentForWarning.NA]: 0,
    [ComplianceProfileCommentForWarning.OPTIONAL]: 1,
    [ComplianceProfileCommentForWarning.REQUIRED]: 2
};
export const complianceCommentForWarningRankMapFR = {
    [ComplianceProfileCommentForWarning.OPTIONAL]: 0,
    [ComplianceProfileCommentForWarning.REQUIRED]: 1,
    [ComplianceProfileCommentForWarning.NA]: 2 // "S/O"
};
//# sourceMappingURL=ComplianceProfileRulesAssociationConstants.js.map